const bankList = {
  bank: {
    3: '004 台灣銀行|12/14',
    4: '005 土地銀行|12/13',
    5: '006 合作金庫|11/13',
    6: '007 第一銀行|11',
    7: '008 華南銀行|12',
    6457: '009 彰化銀行|14',
    10: '011 上海銀行|14',
    11: '012 台北富邦銀行|12/14',
    12: '013 國泰世華銀行|11/12/14',
    13: '016 高雄銀行|12',
    14: '017 兆豐商銀|11/14',
    15: '020 瑞穗銀行|14',
    6084: '021 花旗|10/14',
    17: '025 首都銀行|11/13/14',
    18: '039 澳商澳盛|7/9/10/11/14',
    16: '048 王道商業銀行|48',
    19: '050 台灣企銀|11',
    21: '052 渣打銀行|11/12/13/14',
    22: '053 台中商銀|12',
    23: '054 京城商銀|12',
    24: '056 花蓮企銀|',
    25: '057 臺東企銀|',
    26: '073 日聯銀行|',
    5369: '081 匯豐商銀|12/14',
    27: '083 英商渣打|',
    28: '101 大台北商銀|13',
    29: '102 華泰商行|13',
    30: '103 台灣新光|13/14',
    33: '108 陽信商銀|11/12',
    36: '118 板信商銀|14',

    47: '387 LINE Pay Money|14',
    48: '388 全盈支付|14',
    49: '389 全支付|14',
    50: '390 悠遊付|14',
    51: '391 一卡通|14',
    52: '392 愛金卡|14',
    54: '394 國際連|14',
    55: '395 橘子支付|14',
    56: '396 街口支付|14',
    57: '397 歐付寶|14',
    58: '398 簡單付|14',

    111: '803 聯邦商銀|12/14',
    112: '804 匯豐中|',
    113: '805 遠東商銀|14',
    114: '806 元大商銀|13/14',
    115: '807 永豐商銀|14',
    116: '808 玉山商銀|12/13',
    117: '809 凱基銀行|12',
    118: '810 星展寶銀行|11/12',
    120: '812 台新商銀|14',
    121: '814 大眾商銀|12/14',
    122: '815 日盛商銀|14',
    123: '816 安泰商銀|14',
    124: '822 中國信託|12/13/14',
    125: '826 樂天銀行|14',
    126: '824 連線商業銀行|14',
    127: '147 三信商銀|14',
    128: '823 將來銀行|12/13/14',
  },
  twpay: {
    3: '004 台灣銀行|12/14',
    4: '005 土地銀行|12/13',
    5: '006 合作金庫|11/13',
    6: '007 第一銀行|11',
    7: '008 華南銀行|12',
    6457: '009 彰化銀行|14',
    10: '011 上海銀行|14',
    14: '017 兆豐商銀|11/14',
    114: '806 元大商銀|13/14',

    19: '050 台灣企銀|11',
    1999: '103 台灣新光|',
    2000: '114 基隆一信|',
    2001: '115 基隆二信|',
    2002: '119 淡水一信|',
    2003: '130 新竹一信|',
    2004: '132 新竹三信|',
    2005: '162 彰化六信|',
    2006: '216 花蓮二信|',
    2007: '700 郵局|',
    2008: '815 日盛商銀|',
    2009: '952 南農中心|',
  },
  post: { 110: '700 郵局|14' },
  credit_cooperative: {
    31: '104 台北五信|12/13/14',
    32: '106 台北九信|13',
    34: '114 基隆一信|13',
    35: '115 基隆二信|11',
    37: '119 淡水一信|13/14',
    38: '120 淡水信用|13/14',
    39: '124 宜蘭信用|14',
    40: '127 桃園信用|11/14',
    41: '130 新竹一信|14',
    42: '132 新竹三信|13',
    43: '133 新竹五信|',
    44: '135 新竹十信|',
    45: '139 竹南信用|12',
    47: '146 台中二信|14',
    48: '147 三信銀行|10',
    51: '158 彰化一信|14',
    52: '161 彰化五信|14',
    53: '162 彰化六信|13',
    54: '163 彰化十信|13/14',
    55: '165 鹿港信用|14',
    56: '172 斗六信用|',
    57: '176 嘉義一信|',
    58: '178 嘉義三信|14',
    59: '179 嘉義四信|14',
    60: '183 新營信用|',
    61: '188 台南三信|13/14',
    62: '190 台南五信|',
    63: '191 台南六信|',
    65: '198 鳳山信用|',
    67: '203 高雄二信|13/14',
    68: '204 高雄三信|14',
    69: '215 花蓮一信|13/14',
    70: '216 花蓮二信|14',
    71: '219 東市信用|',
    72: '222 澎湖一信|14',
    73: '223 澎湖二信|14',
    74: '224 金門信用|14'
  },
  peasant_association: {
    88: '600 農金資中心|14',
    89: '603 基隆市農會|14',
    90: '605 高雄市農會|13',
    91: '606 台北縣農會|14',
    92: '607 宜蘭縣農會|14',
    93: '608 桃園縣農會|13/14',
    94: '610 新竹縣農會|14',
    95: '611 苗栗縣農會|14',
    97: '613 南投縣農會|14',
    98: '614 彰化縣農會|14',
    99: '616 雲林縣農會|14',
    100: '617 嘉義縣農會|14',
    101: '618 台南縣農會|14',
    102: '619 高雄縣農會|14',
    103: '620 屏東縣農會|14',
    104: '621 花蓮縣農會|14',
    105: '622 台東縣農會|14',
    106: '623 台北市農會|14',
    107: '624 澎湖縣農會|14',
    108: '625 台中市農會|13',
    109: '627 連江縣農會|14',
    126: '901 大里農會|13',
    127: '903 汐止農會|11',
    128: '904 新莊農會|13/14',
    129: '905 九如農會|',
    130: '908 玉井農會|',
    131: '910 寶山農會|',
    6109: '911 松農|',
    132: '912 冬農|13',
    134: '916 草屯農會|13',
    135: '918 東勢農會|',
    136: '919 沙鹿農會|',
    137: '922 台南市農會|13',
    139: '925 竹山農會|',
    140: '928 板橋農會|13',
    13951: '951 北投農會|',
    141: '954 中農中心|14',
    142: '955 竹南農會|',
    143: '952 南農中心|',
  },
  fisherman_association: {
    75: '503 基隆漁會|14',
    76: '504 瑞芳漁會|14',
    77: '505 蘇澳漁會|14',
    78: '506 桃園漁會|14',
    79: '507 新竹漁會|14',
    80: '512 雲林漁會|14',
    81: '515 嘉義漁會|14',
    82: '517 台南市漁會|14',
    83: '518 台南縣漁會|14',
    84: '520 小港漁會|14',
    85: '521 興達港漁會|14',
    86: '523 屏東縣漁會|14',
    87: '524 新港區漁會|14',
    88: '525 澎湖漁會|14'
  }
}

/**
 * 获取银行列表
 * @param {string} type - 银行类型,type为空时返回所有银行列表
 * @returns {Array} 银行列表
 */
export function getBankOptionItems (type) {
  let list = []
  if (type) {
    list = bankList[type]
  } else {
    list = Object.values(bankList).reduce((acc, key) => {
      acc.push(...Object.values(key))
      return acc
    }, [])
  }
  const result = Object.keys(list).map(key => {
    const item = list[key]
    const name = item.split('|')[0]
    return {
      text: name,
      value: name,
      order: name.split(' ')[0]
    }
  }).sort((a, b) => a.order - b.order)

  return result
}

export default bankList
